import React from "react"
import Helmet from "react-helmet"
import { Container, Row, Col } from "react-bootstrap"
import Layout from "../../../components/layout"
import Modal from "../../../components/popup2/popup"
import JanowoTwoVisual from "../../../components/estates/janowotwo/janowoTwoVisual"
import SearchPuck from "@/components/search/searchPuck"
import EstateDisclaimer from "@/components/estates/estateDisclaimer"
import PuckHeader from "@/components/estates/puck/puckHeader"
import PuckDescription from "@/components/estates/puck/puckDescription"
import PuckVisual from "@/components/estates/puck/puckVisual"
import LogBuilding from "@/components/estates/logBuilding"
import list from "@/flats/flatList/puckArray"
import PuckEstatePlan from "@/components/estates/puck/puckEstatePlan"
import PuckLocalization from "@/components/estates/puck/puckLocalization"
import { logs } from "@/data/diary/buildingLogsPuck"
import EstateHeader from "@/components/estates/estateHeader"

import slide0 from "@/images/z-29/puck-main-z29.jpg"
import slide1 from "@/images/z-28/puck/slide-1.jpg"
// import slide2 from "@/images/z-28/puck/slide-2.jpg"
import slide3 from "@/images/z-29/puck-side.jpg"

import PuckCatalog from "@/components/estates/puck/puckCatalog"
import EstateFlatInfo from "@/components/estates/estateFlatInfo"

function Puck({ location }) {
  const scrollDestination =
    location && location.state && location.state.position
  // const sortedList = list.sort((a, b) => (!!a[13] ? 1 : -1))
  return (
    <>
      <Helmet>
        <title>WILLBUD | Osiedle Pogodne w Pucku</title>
      </Helmet>
      <Layout>
        <EstateHeader
          title={`Osiedle Pogodne w\u00A0Pucku`}
          place={"PUCK, UL. POGODNA"}
          // price={8365}
          promo={"BUDYNEK A1 JUŻ W SPRZEDAŻY - ZAPOZNAJ SIĘ Z KOLEJNYMI LOKALAMI"}
          inProgress
        />
        <JanowoTwoVisual
          slides={[slide0, slide1, slide3]}
          alt={`Osiedle Pogodne w Pucku Wizualizacja`}
        />
        <PuckHeader scrollDestination={scrollDestination} />
        {/* <EstateModalForm
          title={"Osiedle Pogodne w Pucku"}
          estate={"Osiedle Pogodne w Pucku"}
        />*/}

        <PuckDescription />
        <PuckCatalog />
        <PuckVisual />
        {/*<EstateVisualDownload />*/}

        <PuckEstatePlan scrollDestination={scrollDestination} />
        <PuckLocalization />

        <SearchPuck list={list} estate="puck" />
        <Container className="no-padding">
          <Row>
            <Col lg={6} md={12}>
              <p>
                Cena miejsca postojowego naziemnego: 10 000 zł brutto
              </p>
              <p>
                Cena miejsca postojowego w hali garażowej: 35 000 zł brutto
              </p>
              <p>
                Cena 1m2 komórki lokatorskiej: 3 000 zł brutto
              </p>
              <p>
                Cena miejsca postojowego na jednoślad w hali garażowej: 5 000 zł brutto
              </p>
              <EstateFlatInfo >
                <p>
                  Niniejszy cennik obowiązuje od dnia 08.07.2026 r.
                </p>
              </EstateFlatInfo>
            </Col>
            <Col lg={1} md={12}></Col>
            <Col lg={5} md={12}>
              <p><strong>Historia cen</strong></p>
              <p className={"price-info"}>

                <a href="/assets/files/puck/HISTORIA CEN OD DNIA 01.07.2026 DO DNIA 07.07.2026, OSIEDLE POGODNE W PUCKU.pdf" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 01.07.2026 DO DNIA 07.07.2026
                  </span>
                </a>
                <br/>
                <a href="/assets/files/puck/H64PV5-K.PDF" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 27.04.2026 DO DNIA 30.06.2026
                  </span>
                </a>
                <br/>
                <a href="/assets/files/puck/HISTORIA CEN OD DNIA 29.03.2026 DO DNIA 26.04.2026, OSIEDLE POGODNE W PUCKU.pdf" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 29.03.2026 DO DNIA 26.04.2026
                  </span>
              </a>
                <br/>
                <a href="/assets/files/puck/HISTORIA CEN OD DNIA 14.03.2026 DO DNIA 28.03.2026, OSIEDLE POGODNE W PUCKU.pdf" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 14.03.2026 DO DNIA 28.03.2026
                  </span>
              </a>
                <br/>
                <a href="/assets/files/puck/HISTORIA CEN OD DNIA 20.02.2026 DO DNIA 13.03.2026, OSIEDLE POGODNE W PUCKU.pdf" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 20.02.2026 DO DNIA 13.03.2026
                  </span>
                </a>
                <br/>
                <a href="/assets/files/puck/HISTORIA CEN OD DNIA 13.11.2025 DO DNIA 19.02.2026, OSIEDLE POGODNE W PUCKU.pdf" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 13.11.2025 DO DNIA 19.02.2026
                  </span>
                </a>
                <br/>
                <a href="/assets/files/puck/HISTORIA CEN OD DNIA 07.11.2025 DO DNIA 12.11.2025_OSIEDLE POGODNE W PUCKU.pdf" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 07.11.2025 DO DNIA 12.11.2025
                  </span>
                </a>
                <br/>
                <a href="/assets/files/puck/HISTORIA CEN OD DNIA 13.10.2025 DO DNIA 06.11.2025_OSIEDLE POGODNE W PUCKU.pdf" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 13.10.2025 DO DNIA 06.11.2025
                  </span>
                </a>
                <br/>

                <a href="/assets/files/puck/HISTORIA CEN OD DNIA 11.09.2025 DO DNIA 12.10.2025_OSIEDLE POGODNE W PUCKU.pdf" rel="nofollow" target="_blank" >
                  <span >
                    CENNIK HISTORYCZNY OBOWIĄZUJĄCY OD DNIA 11.09.2025 DO DNIA 12.10.2025
                  </span>
                </a>


              </p>
              <p><strong>Prospekt informacyjny</strong></p>
              <p>
                  <a href="/assets/files/puck/2026.06.25-Osiedle-Pogodne-Puck-Prospekt-informacyjny_A1_A2.pdf" target="_blank" rel="nofollow">
                    2026.06.25 - Osiedle Pogodne Puck - A1_A2
                  </a>
              </p>
            </Col>
          </Row>

        </Container>
        {/*<Video video="https://www.youtube.com/embed/xsh54VpDxOc" />*/}
        <LogBuilding
          logs={logs}
          anchor={`/pl/oferta/osiedle-pogodne-w-pucku/#diary`}
        />

        <EstateDisclaimer />
        <Modal />
      </Layout>
    </>
  )
}

export default Puck
